module.exports = {
  noCharges: 'Kostenlose Lieferung.',
  from: 'Von',
  to: 'bis',
  miles: 'Meilen',
  km: 'Km',
  chargesPerMile: 'Kosten per Meile',
  chargesByMiles: 'Kosten per Meilen',
  chargesPerKm: 'Kosten per Kilometer',
  chargesByKms: 'Kosten per Kilometers',
  chargesByInvoice: 'Liefergebühren abhängig von Bestellungssumme',
  defaultCharges: 'Standardgebühr',
};



// WEBPACK FOOTER //
// ./src/lang/de/state.js